import { Helmet } from "react-helmet-async";

const SITE = "https://itoworldwide.com";

// Reusable per-page SEO: unique title, description, canonical, OG/Twitter,
// keywords, robots, and optional JSON-LD (object or array of schema nodes).
export function Seo({
  title,
  description,
  path = "/",
  image = `${SITE}/ito-logo.png`,
  imageAlt,
  keywords,
  type = "website",
  jsonLd,
}) {
  const url = `${SITE}${path}`;
  return (
    <Helmet prioritizeSeoTags>
      <title>{title}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
      <link rel="canonical" href={url} />
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content="Indian Transport Organisation" />
      <meta property="og:locale" content="en_IN" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      <meta property="og:image:alt" content={imageAlt || title} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      <meta name="twitter:image:alt" content={imageAlt || title} />
      {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
    </Helmet>
  );
}
